module.exports = __webpack_public_path__ + "static/media/MatthewBlagg-resume.4bce5597.pdf";